/* eslint-disable @typescript-eslint/no-empty-function */
import { ComponentType, lazy } from "react";

export function safeLazy<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch((err) => {
      console.error("Chunk load failed, reloading app...", err);
      window.location.reload();
      return new Promise<never>(() => {});
    })
  );
}
